module.exports = __webpack_public_path__ + "img/cmdb_header_bg.8fce46db.png";